import { forwardRef, useId } from 'react'
import type { InputHTMLAttributes, ReactNode } from 'react'

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'type'> {
  checked?: boolean
  onChange?: (next: boolean) => void
  label?: ReactNode
  loading?: boolean
  offLabel?: string
  onLabel?: string
  wrapperClassName?: string
}

export const Toggle = forwardRef<HTMLInputElement, Props>(function Toggle(
  { checked, onChange, label, loading = false, disabled, offLabel = 'OFF', onLabel = 'ON', className, wrapperClassName, id, ...rest },
  ref,
) {
  const autoId = useId()
  const inputId = id ?? autoId
  const classes = [
    'dsTg',
    disabled || loading ? 'is-disabled' : '',
    loading ? 'is-busy' : '',
    wrapperClassName ?? '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <label className={classes} htmlFor={inputId}>
      <input
        ref={ref}
        id={inputId}
        type="checkbox"
        className={`dsTg__input ${className ?? ''}`.trim()}
        checked={checked}
        onChange={(event) => onChange?.(event.target.checked)}
        disabled={disabled || loading}
        {...rest}
      />
      <span className="dsTg__track" aria-hidden="true">
        <span className="dsTg__thumb" />
        <em>{offLabel}</em>
        <em>{onLabel}</em>
      </span>
      {label && <span className="dsTg__label">{label}</span>}
    </label>
  )
})
